<template>
  <div class="row">
    <div class="col-md-12">
      <vue-good-table
        mode="remote"
        :columns="columns"
        :rows="rows"
        :totalRows="totalRecords"
        :sort-options="{
          enabled: true,
        }"
        :group-options="{
          enabled: true,
          headerPosition: 'bottom',
        }"
        :isLoading.sync="isLoading"
        styleClass="vgt-table bordered"
        :pagination-options="{
          enabled: true,
          mode: 'registros',
          position: 'top',
          perPage: 10,
          nextLabel: 'siguiente',
          prevLabel: 'anterior',
          rowsPerPageLabel: 'Filas por página',
          ofLabel: 'de',
          pageLabel: 'páginas', // for 'pages' mode
          allLabel: 'Todos',
        }"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
        @on-row-click="onRowClick"
      >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'amount'">
          <span>$ {{ props.row.amount | formatNumberCurrency }}</span>
        </span>
        <span v-else-if="props.column.field == 'fee_amount'">
          <span>$ {{ props.row.fee_amount | formatNumberCurrency }}</span>
        </span>
        <span v-else-if="props.column.field == 'iva'">
          <span>$ {{ props.row.iva | formatNumberCurrency }}</span>
        </span>
        <span v-else-if="props.column.field == 'total'">
          <span>$ {{ props.row.total | formatNumberCurrency }}</span>
        </span>
        <span v-else>
          {{props.formattedRow[props.column.field]}}
        </span>
      </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import axiosAdelaService from '@/axios/axiosAdelaService'

export default {
  components: {
    VueGoodTable
  },
  data () {
    return {
      rows: [],
      isLoading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 10
      },
      columns: [
        {
          label: 'Recibo',
          field: 'receipt_id',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Empresa',
          field: 'enterprise_name',
          filterOptions: {
            placeholder: 'Empresa',
            enabled: true,
            filterMultiselectDropdownItems: []
          }
        },
        {
          label: 'Estatus',
          field: 'status_name',
          filterOptions: {
            placeholder: 'Estatus',
            enabled: true,
            filterMultiselectDropdownItems: []
          }
        },
        {
          label: 'Generado',
          field: 'creation_date',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Pagado',
          field: 'paid_date',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Monto',
          field: 'amount',
          width: '150px',
          type: 'number',
          headerField: this.sumFinalAmount,
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Comisión',
          field: 'fee_amount',
          width: '120px',
          type: 'number',
          headerField: this.sumFinalFeeAmount,
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'IVA',
          field: 'iva',
          width: '100px',
          type: 'number',
          headerField: this.sumFinalIva,
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Total',
          field: 'total',
          width: '150px',
          type: 'number',
          headerField: this.sumFinalTotal,
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Referencia',
          field: 'reference',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Tipo Referencia',
          field: 'reference_type',
          filterOptions: {
            placeholder: 'Tipo Referencia',
            enabled: true,
            filterMultiselectDropdownItems: []
          }
        }
      ]
    }
  },
  methods: {
    sumFinalAmount (rowObj) {
      let sum = 0
      this.$_.forEach(rowObj.children, function (value) {
        sum += value.amount
      })
      return '$ ' + this.$formatNumberCurrency(sum)
    },
    sumFinalFeeAmount (rowObj) {
      let sum = 0
      this.$_.forEach(rowObj.children, function (value) {
        sum += value.fee_amount
      })
      return '$ ' + this.$formatNumberCurrency(sum)
    },
    sumFinalIva (rowObj) {
      let sum = 0
      this.$_.forEach(rowObj.children, function (value) {
        sum += value.iva
      })
      return '$ ' + this.$formatNumberCurrency(sum)
    },
    sumFinalTotal (rowObj) {
      let sum = 0
      this.$_.forEach(rowObj.children, function (value) {
        sum += value.total
      })
      return '$ ' + this.$formatNumberCurrency(sum)
    },
    updateParams (newProps) {
      this.serverParams = Object.assign({ page: 0 }, this.serverParams, newProps)
    },
    onRowClick (params) {
      this.$router.push({ name: 'receiptsProcess', params: params })
    },
    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange (params) {
      console.log(params)
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field
        }
      })
      this.loadItems()
    },
    onColumnFilter (params) {
      this.updateParams(params)
      this.loadItems()
    },
    async loadItems (first = false) {
      try {
        const response = await axiosAdelaService.post('/getReceipts', JSON.stringify({
          first: first,
          ...this.serverParams
        }))
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          this.rows = [
            {
              receipt_id: 'Totales',
              diet: '',
              count: '',
              children: response.data.rows
            }
          ]
          if (response.data.enterprisesFilter) {
            const enterpriseColumn = this.$_.find(this.columns, (column) => {
              return column.field === 'enterprise_name'
            })
            this.$_.set(enterpriseColumn, 'filterOptions.filterMultiselectDropdownItems', response.data.enterprisesFilter)
          }
          if (response.data.statusFilter) {
            const statusColumn = this.$_.find(this.columns, (column) => {
              return column.field === 'status_name'
            })
            this.$_.set(statusColumn, 'filterOptions.filterMultiselectDropdownItems', response.data.statusFilter)
          }
          if (response.data.referenceTypeFilter) {
            const referenceTypeColumn = this.$_.find(this.columns, (column) => {
              return column.field === 'reference_type'
            })
            this.$_.set(referenceTypeColumn, 'filterOptions.filterMultiselectDropdownItems', response.data.referenceTypeFilter)
          }
        }
      } catch (error) {
        this.showError('No se pudieron obtener los recibos intentalo mas tarde.')
      }
    }
  },
  async mounted () {
    this.loadItems(true)
  }
}
</script>

<style>

</style>
